export const AURIA_INTENTS = Object.freeze({
  relax: Object.freeze({
    key: "relax",
    label: "Me détendre",
    hint: "Relâcher la pression et le stress.",
    breathingIds: Object.freeze([1, 2, 3]),
    energyRange: Object.freeze([1, 3]),
  }),
  rest: Object.freeze({
    key: "rest",
    label: "Me reposer",
    hint: "Ralentir et laisser le corps souffler.",
    breathingIds: Object.freeze([4, 5, 6]),
    energyRange: Object.freeze([1, 2]),
  }),
  recenter: Object.freeze({
    key: "recenter",
    label: "Me recentrer",
    hint: "Retrouver clarté et présence.",
    breathingIds: Object.freeze([7, 8, 9]),
    energyRange: Object.freeze([2, 4]),
  }),
});

export const AURIA_INTENT_LIST = Object.freeze(Object.values(AURIA_INTENTS));

export function isAuriaIntent(value) {
  return typeof value === "string" && Boolean(AURIA_INTENTS[value]);
}

export function getAuriaIntent(value) {
  return AURIA_INTENTS[value] || AURIA_INTENTS.relax;
}
